import { Box, Stack } from "@mui/material";
import useLocationQueryDateRange from "../../../v2/hooks/useLocationQueryDateRange";
import {Link as RouterLink, useParams} from "react-router-dom";
import useGetOrgBillingBreakdown from "./Utilities/hooks/useGetOrgBillingBreakdown";
import BillingsTable from "./Utilities/BillingsTable";
import DateRangeForm from "../../../v2/common/DateRangeForm";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import React from "react";

export default function OrganizationBillingsBreakdown() {
    const { orgName } = useParams();
    const { startDate, endDate, setDates } = useLocationQueryDateRange();
    const payload = { startDate, endDate }
    const { columns, totalCount, rows, loading } = useGetOrgBillingBreakdown(payload, orgName);

    return (
        <Box sx={styles.root}>
            <Box sx={styles.container}>
                <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
                    <RouterLink to={'/billings'} className="tms-no-underline">
                        <Box sx={styles.backLink}>
                            <Box>
                                <ArrowBackIosNewIcon sx={styles.arrowBack}/>
                            </Box>
                            <Box mt={'1px'}>Back to billings</Box>
                        </Box>
                    </RouterLink>
                </Box>
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    sx={styles.formContainer}
                    spacing={2}
                >
                    <Box component={"h1"} sx={styles.heading}>
                       Billings breakdown
                    </Box>
                    <Box sx={{ display: "flex", gap: "10px" }}>
                        <DateRangeForm
                            startDate={startDate}
                            endDate={endDate}
                            setDates={setDates}
                        />
                    </Box>
                </Stack>

                <Box>
                    <BillingsTable
                        rows={rows}
                        columns={columns}
                        totalCount={totalCount}
                        loading={loading}
                    />
                </Box>
            </Box>
        </Box>
    );
}

const styles = {
    root: {
        fontFamily: "LarsseitRegular",
        letterSpacing: "-0.02em",
        color: "#0C2728",
        backgroundColor: "#EFEAE7",
        pt: "109px",
        pb: 10,
        minHeight: "100vh",
    },
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: "1440px",
        position: "relative",
    },
    formContainer: {
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", md: "center" },
        mb: { xs: "24px", sm: "40px" },
        mt: { xs: "18px", sm: "24px" }
    },
    heading: {
        m: 0,
        fontFamily: "LarsseitMedium",
        fontSize: 24,
        lineHeight: 1.2,
        letterSpacing: "-0.02em",
        color: "#0C2728",
        mb: 2
    },
    backLink:{
        color: '#302E2A',
        position: 'relative',
        fontFamily: 'FustatBold',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'flex-end',
        gap: '20px',
    },
    arrowBack: {
        color: '#003300',
        marginRight:'8px',
        borderRadius: '0px',
        fontSize: '14px',
        position: 'absolute',
        left: '0',
        top: '3px'
    },
};
